// extracted by mini-css-extract-plugin
export default {"showMoreContainer":"ShowMore_showMoreContainer__GTnB0","showMore":"ShowMore_showMore__SOCH9","showMoreArrow":"ShowMore_showMoreArrow__7Tw3C"};